import { jsx as a } from "react/jsx-runtime";
import { memo as i, forwardRef as l, useRef as u, useImperativeHandle as c } from "react";
import { converter as p } from "../mdParser.js";
import s from "./MdView.HtmlDiv.js";
const v = i(l(({ description: e, padding: m, justifyContent: o }, f) => {
  const n = (e || "").match("<p>") ? e ?? "" : p.makeHtml(e || ""), r = u(null);
  return c(f, () => ({
    getDynamicHeight: () => {
      var t;
      return (t = r.current) == null ? void 0 : t.clientHeight;
    }
  }), []), /* @__PURE__ */ a(s, { ref: r, html: n, padding: m, justifyContent: o });
}));
export {
  v as default
};
//# sourceMappingURL=MdView.js.map
